/**
 * @fileoverview Selectors for the new companies list state
 * @see {@link src/store/newCompaniesList/newCompaniesList.slice.ts}
 */

import type { RootState } from '@/store/index';

/** Get the full companies list */
const getNewCompaniesList = () => (state: RootState) =>
  state.newCompaniesList.companiesList;

/** Get currently selected companies */
const getSelectedCompanies = () => (state: RootState) =>
  state.newCompaniesList.selectedCompanies;

/** Get visible column fields */
const getColumnsFields = () => (state: RootState) => 
  state.newCompaniesList.columnsField;

/** Get loading state */
const getIsLoadingCompanies = () => (state: RootState) =>
  state.newCompaniesList.isCompaniesLoading;

/** Get view mode (cards vs table) */
const getIsCompaniesCards = () => (state: RootState) =>
  state.newCompaniesList.isCompaniesCards;

const newCompaniesListSelectors = {
  getNewCompaniesList,
  getSelectedCompanies,
  getColumnsFields,
  getIsLoadingCompanies,
  getIsCompaniesCards,
};

export default newCompaniesListSelectors;
